import { agactakiKonular, type AgacDugumu } from "./api";

/**
 * SÜRÜME KONU ATAMA — "TÜMÜNÜ SEÇ" MANTIĞI (UI/UX Dalga 2, M7)
 *
 * Bir alan yüzlerce konu taşıyabiliyor ve sürüme atama bugüne kadar tek tek
 * kutu işaretlemekti; mutabakatta "tümünü seç" istendi. Saf yardımcılar
 * burada: ekran yalnız çiziyor.
 *
 * ÜNİTE SEÇİLEMEZ kuralı korunuyor (sunucu üniteyi 400 ile reddediyor):
 * kimlikler yalnız `agactakiKonular`dan geliyor — o fonksiyon bu depoda
 * üçüncü kopyanın yazılmaması için tek yerde duruyor, burada yeniden
 * yazılmıyor.
 */

export type SecimDurumu = "yok" | "kismi" | "hepsi";

/** Bir ders (ya da herhangi bir düğüm kümesi) altındaki bütün KONU kimlikleri. */
export function konuKimlikleri(dugumler: readonly AgacDugumu[]): string[] {
  return agactakiKonular(dugumler).map((k) => k.id);
}

/** Kimlik kümesinin seçili kümeye göre durumu — onay kutusunun üç hâli. */
export function secimDurumu(
  kimlikler: readonly string[],
  secili: ReadonlySet<string>,
): SecimDurumu {
  if (kimlikler.length === 0) return "yok";
  const secilen = kimlikler.filter((k) => secili.has(k)).length;
  if (secilen === 0) return "yok";
  return secilen === kimlikler.length ? "hepsi" : "kismi";
}

/**
 * Bu kümeyi tamamen seçer; zaten tamamen seçiliyse tamamen bırakır.
 * Başka derslerin seçimine DOKUNMAZ (yeni küme döner).
 */
export function kumeyiDegistir(
  secili: ReadonlySet<string>,
  kimlikler: readonly string[],
): Set<string> {
  const yeni = new Set(secili);
  if (secimDurumu(kimlikler, secili) === "hepsi") {
    for (const k of kimlikler) yeni.delete(k);
  } else {
    for (const k of kimlikler) yeni.add(k);
  }
  return yeni;
}
